/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import "../../assets/css/editor.scss"
import { ILanding, ILandingSection } from "../../data/interfaces"
import { ILandingStore, useLandingStore } from "../../data/store"
import AddMeatDrawer from "./landing-edit/add-meat-drawer"
import ContentClickForm from "./landing-edit/ContentClickForm"
import ContentHoverForm from "./landing-edit/ContentHoverForm"
import FigureDrawForm from "./landing-edit/figure-draw"
import Hotkeys from "./landing-edit/Hotkeys"
import LandingEditModal from "./landing-edit/landing-edit-modal"
import LandingEditOverlay from "./landing-edit/landing-edit-overlay"
import LandingEditorContainer from "./landing-edit/LandingEditorContainer"
import LandingEditPanel from "./landing-edit/LandingEditPanel"
import LandingSectionsIsEdit from "./landing-edit/LandingSectionsIsEdit"
import MakeupDrawer from "./landing-edit/makeup"
import SectionEditDrawer from "./landing-edit/SectionEditDrawer"
import ToolsPanel from "./landing-edit/tools"
import TopPanel from "./landing-edit/top-panel/TopPanel"
import LandingContainer from "./LandingContainer"
import { ILandingSnapshotProps } from "./LandingSnapshotForm"
import ToUp from "./section/ToUp"

/* Protopia Ecosystem component */ 
const LandingEditor = ( props: ILandingSnapshotProps ): JSX.Element => { 
    
    const sections = useSyncState<ILandingSection[]>( useLandingStore.getState().currentLanding.sections )    
     
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => {                
                if( sections.get().length !== currentLanding.sections.length ){                
                    sections.set( currentLanding.sections )
                }
            }
        )

        return () => unsubscribe()
    }, [])
    
    return <LandingEditorContainer>        
        <Hotkeys />
        <TopPanel />
        <div  className={ `d-flex landing-edit-cont` }>   
            <ToolsPanel />    
            <LandingContainer className="is-edit" className2="overflow-x-auto" isEdit>
                <LandingSectionsIsEdit sections={sections.get()} /> 
                <ToUp />
                <ContentHoverForm />
                <ContentClickForm />
                {/* <ContentDoubleClickForm /> */}
                <FigureDrawForm />
            </LandingContainer>
            <LandingEditPanel />
            <SectionEditDrawer /> 
            <AddMeatDrawer />
            <MakeupDrawer />
            <LandingEditModal />
            <LandingEditOverlay />
        </div>
    </LandingEditorContainer>
}
export default LandingEditor